import { render } from "./SignUpOrganizationName.vue?vue&type=template&id=f5069d62&scoped=true"
import script from "./SignUpOrganizationName.vue?vue&type=script&lang=js"
export * from "./SignUpOrganizationName.vue?vue&type=script&lang=js"

import "./SignUpOrganizationName.vue?vue&type=style&index=0&id=f5069d62&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5069d62"]])

export default __exports__